module.exports = __webpack_public_path__ + "static/media/undraw_startup_life_re_8ow9.1138deb2.svg";